<div class="l-master">
	<slot/>
</div>
